import logo from '../src/images/logo.jpg'
import './App.css';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

 
import { Container, Jumbotron, TabContainer } from 'react-bootstrap';
import Home from './Competent/Home/Home';
import Team from './Competent/Team/Team';
import TeamDetail from './Competent/TeamDetail/TeamDetail';

function App() {
   
  return (
    <Router>
    <div className="col-sm-12 col-md-12">
    <img className="col-sm-12 col-md-12"  style={{width:'100%',height:'250px'}} src={logo} alt=""/>
      

      
      <Switch>
        <Route exact path="/">
          <Home></Home>
        </Route>
        <Route path="/team/:teamId">
          <TeamDetail></TeamDetail>

        </Route>
        <Route path="/home">
          <Home></Home>
        </Route>
        <Route path="/team">
          <Team></Team>
        </Route>
      </Switch>
    </div>
  </Router>
  );
}

export default App;